<template>
  <coozzy-card :title="$t('message.settings.tend.title')">
    <div
      v-if="loading"
      style="height: 30px">
      <coozzy-spinner />
    </div>
    <div
      v-else
      class="row">
      <div class="col-6">
        <coozzy-form-input
          v-model="dateString"
          :filter="'formatDate'"
          type="date"
          :name="$t('message.settings.tend.until') + '*'" />
      </div>
      <div
        class="col-6">
        <coozzy-button
          :disabled="loading || !dateString"
          class="mt-3"
          design="green"
          @click="getRentalIndexCSV">
          {{ $t('message.generic.create') }}
        </coozzy-button>
      </div>
    </div>
  </coozzy-card>
</template>

<script lang="ts">
import Vue, { defineComponent } from 'vue'
import CoozzyCard from '@/framework/components/card/CoozzyCard.vue'
import CoozzySpinner from '@/framework/components/misc/CoozzySpinner.vue'
import CoozzyButton from '@/framework/components/button/CoozzyButton.vue'
import ExportApi from '@/misc/apis/ExportApi'
import CoozzyFormInput from '@/framework/components/form/input/CoozzyFormInput.vue'
import { dateUtils } from '@/mixins/dateUtils'

export default defineComponent({
  name: 'TendExportSettings',
  components: { CoozzyFormInput, CoozzyButton, CoozzySpinner, CoozzyCard },
  mixins: [dateUtils],
  data() {
    return {
      dateString: null,
      loading: false
    }
  },
  methods: {
    base64ToZipBlob(file) {
      const binary = window.atob(file)
      const len = binary.length
      const buffer = new ArrayBuffer(len)
      const view = new Uint8Array(buffer)
      for (let i = 0; i < len; i++) {
        view[i] = binary.charCodeAt(i)
      }
      return new Blob([view], { type: 'application/zip' })
    },
    downloadZip(file, fileName) {
      const url = window.URL.createObjectURL(this.base64ToZipBlob(file))
      const link = document.createElement('a')
      link.href = url
      link.download = fileName
      link.click()
      window.URL.revokeObjectURL(url)
    },
    getRentalIndexCSV() {
      this.loading = true
      const date = this.toObject(this.dateString)
      ExportApi.tendGetRedXAreaModel(date)
        .then(data => {
          this.downloadZip(data.zipUbsSima, 'ubs-sima.zip')
          this.downloadZip(data.zipUbsPk, 'ubs-pk.zip')

          this.loading = false
          Vue.toasted.show(this.$t('message.settings.tend.success'), { type: 'success' })
        }).catch(err => {
          console.log(err)
          Vue.toasted.show(this.$t('message.settings.tend.error'), { type: 'error' })
          this.loading = false
        })
    }
  }
})
</script>

<style scoped lang="scss">

</style>
